// Petalia — Micro-animations

document.addEventListener('DOMContentLoaded', function () {

  // ─── Scroll reveal ────────────────────────────────────────
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(el => {
      if (el.isIntersecting) {
        el.target.classList.add('visible');
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll(
    '.multicolumn-list__item, .collection-list__item, .card-wrapper, .product-card-wrapper'
  ).forEach((el, i) => {
    el.classList.add('reveal');
    if (i % 3 === 1) el.classList.add('reveal-delay-1');
    if (i % 3 === 2) el.classList.add('reveal-delay-2');
    revealObserver.observe(el);
  });

  // NOTE: .shopify-section mass-reveal deliberately removed.
  // Setting opacity:0 on all sections causes permanent white screen on mobile Safari —
  // IntersectionObserver does not always fire for elements already in the viewport
  // when observe() is called (known WebKit/iOS bug).

  // Safety net: any .reveal element not yet visible after 600ms is force-revealed.
  // Guards against IntersectionObserver timing failures on any browser.
  setTimeout(function() {
    document.querySelectorAll('.reveal:not(.visible)').forEach(function(el) {
      el.classList.add('visible');
    });
  }, 600);

  // ─── Hero parallax ────────────────────────────────────────
  const heroMedia = document.querySelector('.slideshow__media, .hero__media');
  if (heroMedia) {
    window.addEventListener('scroll', () => {
      const scrolled = window.pageYOffset;
      if (scrolled < window.innerHeight) {
        heroMedia.style.transform = 'translateY(' + (scrolled * 0.2) + 'px)';
      }
    }, { passive: true });
  }

  // ─── Number counter ───────────────────────────────────────
  function animateCounter(el) {
    const target = parseFloat(el.dataset.target);
    const prefix = el.dataset.prefix || '';
    const suffix = el.dataset.suffix || '';
    const duration = 1500;
    const start = performance.now();

    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(target * eased);
      el.textContent = prefix + current.toLocaleString() + suffix;
      if (progress < 1) requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        counterObserver.unobserve(entry.target);
      }
    });
  });

  document.querySelectorAll('.count-up').forEach(el => {
    counterObserver.observe(el);
  });

});
